import './styles/app.less'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from '@/config'

document.title = config.title
router.beforeEach((to, from, next) => {
  if (to.name == 'order-order' || to.name == 'order-refund' || to.name == '401' || to.name == 'order-return' || to.name == '404' || to.name == 'dashboard' || to.name == 'login') {
    next()
  } else {
    const { currentUser } = store.state.auth
    if (currentUser.onlyAllowRefundOrder) {
      router.push({ name: '401' })
    } else {
      next()
    }
  }
  
})

import './icons' // icon
import './filters'
import './plugins'
import './permission'
import errorHandler from './errorHandler'
import globalComponents from './components'

Vue.config.productionTip = false
Vue.config.errorHandler = errorHandler

Object.keys(globalComponents).forEach(name => Vue.component(name, globalComponents[name]))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
